var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.response && _vm.validUrl
      ? _c(
          "div",
          {
            style: { width: _vm.cardWidth },
            attrs: { id: "loader-container" }
          },
          [_vm._t("loading", [_c("div", { staticClass: "spinner" })])],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.response
      ? _c(
          "div",
          [
            _vm._t(
              "default",
              [
                _c(
                  "div",
                  { staticClass: "wrapper", style: { width: _vm.cardWidth } },
                  [
                    _c("div", { staticClass: "card-img" }, [
                      _c("img", { attrs: { src: _vm.response.image } })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-info" }, [
                      _c("div", { staticClass: "card-text" }, [
                        _c("h1", [_vm._v(_vm._s(_vm.response.title))]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.response.description))])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-btn" }, [
                        _vm.showButton
                          ? _c(
                              "a",
                              {
                                attrs: { href: "javascript:;" },
                                on: { click: _vm.viewMore }
                              },
                              [_vm._v("View More")]
                            )
                          : _vm._e()
                      ])
                    ])
                  ]
                )
              ],
              {
                img: _vm.response.image,
                title: _vm.response.title,
                description: _vm.response.description,
                url: _vm.url
              }
            )
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1328ba6c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1328ba6c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/shared/LinkPrevue.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1328ba6c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/shared/LinkPrevue.vue
// module chunks = 0 1